<!-- v1 <ft-modal id="AccountV2.Components.CreateContestModal"
          header-text="{{'...NewContest' | translate}}" ft-snapshot="vm.contest"
          on-done="vm.create"> — all other options at the modal.js defaults -->
<ft-modal-overlay [open]="isOpen()">
    <div id="AccountV2.Components.CreateContestModal">
        <ft-modal-chrome-ng
            [headerText]="'flipto.account.sections.platform.photoAdvocacy.NewContest' | translate"
            [doneDisabled]="!!createForm.invalid || !contest().name.trim()"
            (done)="done()"
            (cancel)="cancel()"
        >
            <div ngForm #createForm="ngForm">
                <div class="modal-section-heading">{{ 'flipto.account.sections.platform.photoAdvocacy.ContestName' | translate }}</div>
                <div class="modal-panel modal-panel-input">
                    <input maxlength="50" name="name" [(ngModel)]="contest().name" required type="text">
                </div>

                <div class="modal-section-heading">{{ 'flipto.account.sections.platform.photoAdvocacy.DateRange' | translate }}</div>
                <div class="modal-summary">{{ 'flipto.account.sections.platform.photoAdvocacy.DateRangeDescription' | translate }}</div>
                <div class="modal-panel">
                    <ft-date-range-picker-ng [(startDate)]="contest().startDate"
                                                                      [(endDate)]="contest().endDate" />
                </div>

                <div class="modal-section-heading">{{ 'flipto.account.sections.platform.photoAdvocacy.CloneFromContestDescription' | translate }}</div>
                <div class="modal-panel last">
                    <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
                        <a class="ft-dropdown-toggle"><span>{{ contest().sourceContestName }}</span> <i class="ft-icn-caret-down"></i></a>
                        <ul class="ft-dropdown-menu">
                            @for (sourceContest of menuContests(); track sourceContest) {
                                <li (click)="selectSourceContest(sourceContest)">
                                    <a [class.active]="sourceContest.UUID === contest().sourceContestUUID">
                                        {{ sourceContest.name }}
                                        @if (!!sourceContest.UUID) {
                                            <div>{{ sourceContest.startDate | date: 'MMM dd, yyyy' }} - {{ sourceContest.endDate | date: 'MMM dd, yyyy' }}</div>
                                        }
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </ft-modal-chrome-ng>
    </div>
</ft-modal-overlay>
